import { render } from "./MoolngHeaderMenu.vue?vue&type=template&id=0978acde"
import script from "./MoolngHeaderMenu.vue?vue&type=script&lang=js"
export * from "./MoolngHeaderMenu.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__